// extracted by mini-css-extract-plugin
export var backdropBlur = "_kf-0";
export var contentCard = "_kf-5";
export var frame = "_kf-2";
export var image = "_kf-4";
export var imagePane = "_kf-3";
export var modal = "_kf-1";